<template>
  <div class="index">
    <van-nav-bar title="交押金" left-text="返回" left-arrow @click-left="onClickLeft"/>
    <div v-if="type==1">
      <van-form @submit="onSubmit" class="form">
        <van-field
          readonly
          v-model="CarMsg.cardNumber"
          name="卡号"
          label="卡号"
          placeholder="卡号"
        />
        <van-field
          readonly
          v-model="CarMsg.projectNumber"
          name="项目"
          label="项目"
          placeholder="项目"
        />
        <van-field
          readonly
          v-model="CarMsg.areaName"
          name="区域/楼栋"
          label="区域/楼栋"
          placeholder="区域/楼栋"
        />
        <van-field
          readonly
          v-model="CarMsg.roomName"
          name="房间信息"
          label="房间信息"
          placeholder="房间信息"
        />
        <!-- -------------------------------------------------- -->
        <van-field
          required
          v-model="payForm.name"
          name="姓名"
          label="姓名："
          placeholder="请输入姓名"
          :rules="[{ required: true, message: '请输入姓名' }]"
        />
        <van-field
          required
          v-model="payForm.phone"
          label="手机号："
          maxlength="11"
          placeholder="请输入手机号"
          :rules="[{ required: true, message: '请输入手机号' }]"
        />
        <van-field
          required
          v-model="payForm.code"
          center
          clearable
          maxlength="6"
          label="验证码："
          placeholder="请输入短信验证码"
          :rules="[{ required: true, message: '请输入短信验证码' }]"
        >
          <template #button>
            <div v-if="!smsSendType" class="timeBox" @click="smsSend">发送验证码</div>
            <!-- <van-button v-if="!smsSendType"  size="small"  type="primary" @click="smsSend">发送验证码</van-button> -->
            <van-count-down class="timeBox" v-else @finish="timeFinish" :time="time" format="ss 秒"/>
          </template>
        </van-field>
        <van-field
          v-if="CarMsg.enableFullInfo"
          v-model="payForm.studentNum"
          label="学号"
          placeholder="请输入您的学号"
        />
        <van-field
          v-if="CarMsg.enableFullInfo"
          v-model="specialty"
          label="专业："
          placeholder="请选择专业"
          readonly
          clickable
          @click="specialtyShow = true"

        />
        <van-field
          v-model="payForm.classgrade"
          label="班级："
          placeholder="请输入您的班级"

        />
        <div style="margin: 2rem 16px 1rem">
          <van-button round block type="info" native-type="submit">完成登记并支付{{payDeposit}}元押金</van-button>
        </div>

      </van-form>
      <van-popup v-model="specialtyShow" round position="bottom">
        <!-- 专业下拉 -->
        <van-picker
          title="专业"
          show-toolbar
          :columns="specialtyColumns"
          @confirm="specialtyonConfirm"
          @cancel="specialtyShow = false"
        />
      </van-popup>

    </div>
    <div class="succeed" v-else>
      <van-icon name="checked" size="3rem" color="#4FB640"/>
      <div class="text">信息已提交并已支付押金，请等待管理员确认。</div>
      <van-button style="margin-top:2rem;width:7rem;" round type="info" @click="toPath">返回首页</van-button>
    </div>

  </div>
</template>

<script>
  import wx from 'weixin-js-sdk'

  export default {
    data () {
      return {
        openId: '',
        type: 1,
        // 发送短信按钮
        smsSendType: false,
        // 倒计时
        time: 60 * 1000,
        payForm: {
          name: '',
          phone: '',
          code: '',
          specialty: '',
          classgrade: '',
          studentNum: ''
        },
        // classgrade: '',
        studentNum: '',
        // 专业下拉选择
        specialtyShow: false,
        specialtyColumns: [],
        // 班级下来选择
        // classgradeShow: false,
        classColumns: [],
        // 押金金额
        payDeposit: '999',
        CarMsg: {},
        Arr: []
      }
    },
    created () {
      let CarMsg = JSON.parse(sessionStorage.getItem('carMsg'))
      this.CarMsg = CarMsg
      this.openId = sessionStorage.getItem('openId')
      this.payDeposit = CarMsg.feeAmount.toString()
      console.log(this.CarMsg)
      this.queryClassgroup(CarMsg.projectId)

      let currentUrl = location.href.split('#')[0]

      let data = new FormData()
      data.append('openId', this.openId)
      data.append('url', currentUrl)
      this.$axios.post('/lockapi/smartlock/get-wxconfig-data', data).then(res => {
        if (res.data.success) {
          let dd = res.data.userObject
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: dd.appId, // 必填，公众号的唯一标识
            timestamp: dd.timestamp, // 必填，生成签名的时间戳
            nonceStr: dd.nonceStr, // 必填，生成签名的随机串
            signature: dd.signature, // 必填，签名，见附录1
            jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          })

        } else {
          this.$toast.fail('wxconfig失败，原因：' + res.data.msg + '!')
        }
      }).catch(error => {
        console.log(error)
        this.$toast.fail('wxconfig失败!')
      })

    },
    mounted () {
    },
    methods: {
      queryClassgroup (projectId) {
        let data = {
          projectId: projectId
        }
        this.$axios.post('/lockapi/smartlock/query-classgroup', data).then(res => {
          if (res.data.success) {
            this.Arr = res.data.userObject
            this.specialtyColumns = this.Arr.map(item => item.name)
          } else {
            // this.$toast.fail('查询专业失败的原因：' + res.data.msg + '!')
          }
        }).catch(error => {
          console.log(error)
          //   this.$toast.fail('查询失败!')
        })
      },
      onSubmit () {

        let _that = this

        let data = {
          openId: this.openId,
          cardNumber: this.CarMsg.cardNumber,
          name: this.payForm.name,
          phone: this.payForm.phone,
          code: this.payForm.code,
          clssGroupId: this.payForm.specialty,
          className: this.payForm.classgrade,
          studentNumber: this.payForm.studentNum
        }

        this.$axios.post('/lockapi/smartlock/submit-register-bill', data).then(res => {
          if (res.data.success) {
            //调用微信支付
            let data = res.data.userObject
            if (data.needPay) {
              wx.chooseWXPay({
                timestamp: data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
                package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
                signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                paySign: data.paySign, // 支付签名
                success: function (res) {
                  _that.type = 2
                },
                fail: function (res) {
                }
              })
            } else {
              _that.type = 2
            }
          } else {
            this.$toast.fail('提交失败,原因：' + res.data.msg + '!')
          }
        }).catch(error => {
          this.$toast.fail('提交失败!')
        })

      },
      // 发送短信验证码
      smsSend () {
        if (this.payForm.phone == '') {
          this.$toast('请输入手机号码')
          return
        }

        let data = new FormData()
        data.append('phone', this.payForm.phone)

        this.$axios.post('/lockapi/smartlock/send-verifycode', data).then(res => {
          if (res.data.success) {
            this.time = 60 * 1000
            this.smsSendType = true
            this.$toast('验证码发送成功')
          } else {
            this.$toast.fail('操作失败，原因：' + res.data.msg + '!')
          }
        }).catch(error => {
          this.$toast.fail('操作失败!')
        })

      },
      // 专业下拉选择
      specialtyonConfirm (value) {
        let key = this.specialtyColumns.indexOf(value)
        this.classColumns = this.Arr[key].items.map(item => item.name)
        this.specialty = value
        this.payForm.specialty = this.Arr[key].fid
        // this.classgrade = ''
        this.payForm.classgrade = ''
        this.specialtyShow = false
      },
      // 倒计时结束
      timeFinish () {
        this.smsSendType = false
      },
      // 返回首页
      toPath () {
        location.href = '/#/intelligentLock/portal'
      },
      //   后退
      onClickLeft () {
        location.href = '/#/intelligentLock/payDeposit'
      }

    },
  }
</script>
<style lang="less" scoped>
  .index {
    .form {
      padding-top: 1rem;
      background-color: #fff;

      .van-field {
        font-size: 0.6rem;
      }
    }

    .timeBox {
      width: 3.5rem;
      height: 1.2rem;
      line-height: 1.2rem;
      background-color: #07C160;
      text-align: center;
      color: #fff;
      font-size: 0.6rem;
    }

    .van-field {
      text-align: left;
    }

    .succeed {
      padding-top: 4rem;

      .text {
        margin-top: 1rem;
        text-align: center;
        font-size: 0.7rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/intelligentLock/payDepositForm.vue